import { Menu, MenuProps } from '@mui/material';
import { grey } from '@mui/material/colors';
import { alpha, styled } from '@mui/material/styles';

const CustomMenu = styled((props:MenuProps) => (
    <Menu
      {...props}    
      open={false} 
      elevation={0}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
    //   borderRadius: 4,
      backgroundColor: 'primary.main',
      border: "0.3px solid #545575",
    //   marginTop: theme.spacing(1),
      minWidth: 180,
      padding: 0,
      color: grey[200],
      '& .MuiMenu-list': {
        padding: '0',
        backgroundColor: '#1A1B41'
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: grey[200],
        //   marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
}));

export default CustomMenu
